import type { ComponentType } from "react";
import { Box } from "@mui/material";
import type { ToolbarProps } from "react-big-calendar";
import type { Dayjs } from "dayjs";
import CustomCalendarToolbar from "@/components/CustomCalendarToolbar";
import { RazaEventsCalendarLegend } from "./RazaEventsCalendarLegend";
import type { RazaEventsCalendarEvent } from "./types";

export type RazaEventsCalendarToolbarWithLegendProps = ToolbarProps & {
  events: RazaEventsCalendarEvent[];
  selectedDate: Dayjs;
  setSelectedDate: (d: Dayjs) => void;
  listToggleComponent?: ComponentType;
  hallOverlayEnabled?: boolean;
  onHallOverlayChange?: (enabled: boolean) => void;
};

export function RazaEventsCalendarToolbarWithLegend({
  events,
  selectedDate,
  setSelectedDate,
  listToggleComponent,
  hallOverlayEnabled,
  onHallOverlayChange,
  ...toolbarProps
}: RazaEventsCalendarToolbarWithLegendProps) {
  return (
    <Box
      sx={{
        flexShrink: 0,
        borderBottom: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <CustomCalendarToolbar
        {...toolbarProps}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        listToggleComponent={listToggleComponent}
      />
      <RazaEventsCalendarLegend
        events={events}
        hallOverlayEnabled={hallOverlayEnabled}
        onHallOverlayChange={onHallOverlayChange}
      />
    </Box>
  );
}
